<template>
  <GlobalWindow
    title="历史信息"
    :visible.sync="visible"
    :show="true"
    width="60%"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-table
      :data="currentRowData"
      stripe
      style="width: 100%"
    >
      <el-table-column
        v-if="disable === '用户名' ? false : true"
        :prop="disable ? 'account_name' : 'user_name'"
        label="用户名"
        min-width="180"
      />
      <el-table-column
        v-if="disable === '昵称' ? false : true"
        prop="nickname"
        label="昵称"
        min-width="180"
      />
      <el-table-column
        v-if="disable === '开始时间' ? false : true"
        prop="start_time"
        label="开始时间"
        min-width="180"
      />
      <el-table-column
        v-if="disable === '结束时间' ? false : true"
        prop="end_time"
        label="结束时间"
        min-width="180"
      />
      <el-table-column
        prop="status"
        label="状态"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <el-tag v-if="scope.row.status === 1" type="success">正常</el-tag>
          <el-tag v-if="scope.row.status === 2" type="danger">停止</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- <pagination-right :scroll="true" :total="total" @size-change="fetchPageSize" @current-change="fetchCurrentPage" /> -->
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
// import PaginationRight from '@/components/PaginationRight/index.vue'
// import moment from 'moment'
export default {
  name: 'HistoryWechatUserData',
  components: { GlobalWindow },
  props: {
    disable: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentRowData: {},
      visible: false
    }
  },
  methods: {
    open(data) {
      this.visible = true
      this.currentRowData = data // 获取当前行的ID
    },
    // 关闭dialog
    close() {
      this.form = {}
      this.timeValue = null
    },
    confirm() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
</style>
